import { render, staticRenderFns } from "./LetzteLaeufe.vue?vue&type=template&id=4a12f521&scoped=true"
import script from "./LetzteLaeufe.vue?vue&type=script&lang=js"
export * from "./LetzteLaeufe.vue?vue&type=script&lang=js"
import style0 from "./LetzteLaeufe.vue?vue&type=style&index=0&id=4a12f521&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a12f521",
  null
  
)

export default component.exports